import { USER_LOGGED_OUT_EVENT } from '@/lib/constants/auth-events';

/**
 * Clear the client-side session (stored user profile) and notify listeners. Used on
 * explicit logout and when a session is found invalid.
 *
 * Only removes `user` — other user-scoped keys are left to their own stores' lifecycle.
 * Cannot clear `connect.sid`/`cs_refresh_token` (HttpOnly, server-only) — that's why
 * logout also calls the API to relay the cookie-clearing Set-Cookie.
 */
export function clearInvalidSession(): void {
  if (typeof window === 'undefined') return;

  localStorage.removeItem('user');
  window.dispatchEvent(new CustomEvent(USER_LOGGED_OUT_EVENT));
}
